var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1700px",
        title: "AI审单",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        "append-to-body": "",
        top: "5vh",
        draggable: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "div",
            { staticClass: "form" },
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    "label-width": "auto",
                    rules: _vm.rules,
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "总税金", prop: "taxAmount" } },
                    [
                      _c("number-range", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0.01, precision: 2, max: 990000 },
                        model: {
                          value: _vm.form.taxAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "taxAmount", $$v)
                          },
                          expression: "form.taxAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "总价值", prop: "totalAmount" } },
                    [
                      _c("number-range", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0.01, precision: 2, max: 990000 },
                        model: {
                          value: _vm.form.totalAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalAmount", $$v)
                          },
                          expression: "form.totalAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "总条目", prop: "calcCount" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "controls-position": "right",
                          min: 1,
                          precision: 0,
                          step: 1,
                        },
                        model: {
                          value: _vm.form.calcCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "calcCount", $$v)
                          },
                          expression: "form.calcCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      return _vm.createTask("formRef")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.rowData.invoiceTaskId ? "重新生成" : "生成发票")
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "data" },
            [
              _c("BaseTable", {
                attrs: {
                  tableData: _vm.tableData,
                  height: "787",
                  isPager: false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "productName",
                    fn: function (row) {
                      return [
                        _c("p", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("唛头"),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.scope.mark)),
                          ]),
                        ]),
                        _c("p", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Product name"),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.scope.nameEN)),
                          ]),
                        ]),
                        _c("p", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("中文品名"),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.scope.nameCH)),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "usedFor",
                    fn: function (row) {
                      return [
                        _c("p", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Material"),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.scope.material)),
                          ]),
                        ]),
                        _c("p", [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Used for"),
                          ]),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.scope.usedFor)),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "qty",
                    fn: function (row) {
                      return [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c("p", { staticStyle: { width: "50%" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("箱数"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.packages)),
                            ]),
                          ]),
                          _c("p", { staticStyle: { width: "50%" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("产品净重"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.netWeight)),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c("p", { staticStyle: { width: "50%" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("产品个数"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.qty)),
                            ]),
                          ]),
                          _c("p", { staticStyle: { width: "50%" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("产品毛重"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.grossWeight)),
                            ]),
                          ]),
                        ]),
                        _c("div", [
                          _c("p", { staticStyle: { width: "50%" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("产品单价"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.unitPrice)),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "ston",
                    fn: function (row) {
                      return [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c("p", { staticStyle: { width: "50%" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("铜净重"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.copperNetWeight)),
                            ]),
                          ]),
                          _c("p", { staticStyle: { width: "50%" } }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("钢铝净重"),
                            ]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(_vm._s(row.scope.steelAluminiumNetWeight)),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "hsCode",
                    fn: function (row) {
                      return [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(row.scope.hsCode)),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "totalCalculateRate",
                    fn: function (row) {
                      return [
                        _vm._v(
                          " " + _vm._s(row.scope.totalCalculateRate) + " "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "bottom" },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._l(row.scope.rateList, function (item) {
                                  return [
                                    item.addRate && !item.isAddRateExempt
                                      ? _c(
                                          "div",
                                          {
                                            key: item.name,
                                            staticClass: "addRate-item",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "title" },
                                              [_vm._v(_vm._s(item.name) + ":")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(item.addRate) + " %"
                                              ),
                                            ]),
                                            item.isAddRateExempt
                                              ? _c(
                                                  "span",
                                                  { staticClass: "tip" },
                                                  [_vm._v("豁免")]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            ),
                            _c("img", {
                              staticStyle: { "margin-top": "5px" },
                              attrs: {
                                src: require("@/assets/images/bill/tax-detail.png"),
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "totalAmount",
                    fn: function (row) {
                      return [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(row.scope.totalAmount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c("template", { slot: "footer" }, [
        _c("div", { staticClass: "footer flex_c_c" }, [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c("div", { staticClass: "ok flex_c_c", on: { click: _vm.ok } }, [
            _vm._v("确认录入"),
          ]),
        ]),
      ]),
      _c("ReCreatedInvoiceDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
          ok: _vm.reCreated,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }